import moment from 'moment';
import {BookingType, IBooking, IBookingFromPouch, IBookingTimeChangelogEntry, IBookingTimeChangelogEntryFromPouch, bookingStatusType, preAuthStatus, servicePaymentType} from 'shared-types/index';
import BookingLookupService from "external-services/booking-lookup-service";
import DateUtilsService from "external-services/date-utils-service";
import AdminService from "external-services/diary-admin-service/admin.service";

const NS = 'BookingNormaliseService';

class BookingNormaliseService {

  public normalizeModelToView(bookingFromPouch: IBookingFromPouch): IBooking {

    const booking: IBooking = bookingFromPouch as unknown as IBooking;
    if (booking) {
      try {
        booking.time = DateUtilsService.dateTimeStrToDate(bookingFromPouch.time);
      } catch (e) {
        console.log('Fix booking.time', booking._id, booking.time);
        booking.time = moment(booking.time).toDate();
      }

      booking.bookingEnd = new Date(booking.time);
      booking.bookingEnd.setMinutes(booking.bookingEnd.getMinutes() + Number(booking.duration));
      booking.bookedAt = new Date(booking.bookedAt);

      if (booking.paymentSummary && booking.paymentSummary.paymentType === servicePaymentType.preAuth) {
        booking.paymentSummary.amountHeld = (booking.paymentSummary.amountDue - (booking.paymentSummary.preAuthReleasedAmount + booking.paymentSummary.preAuthChargedAmount)).toFixed(2);
        this.normalizePreAuthRelease(booking);
      }

      booking.primaryTableId = BookingLookupService.getPrimaryTableId(booking);

      booking.tags = booking.tags || [];
      booking.timeChangelog = bookingFromPouch.timeChangelog?.map((x)=>this.NormalizeBookingTimeChangeLogEntry(x)) || [];
      BookingLookupService.scriptInjectionPrevention(booking);
    }
    return booking;
  }
  public checkDuration(duration: string | number, minBookingDuration: number): number {
    let dur;
    /**
     * Just added this as a safe guard. Had an intermittent scenario where value was converted to string, which caused problems
     * when reading back in.
     */
    if (typeof duration === 'string') {
      dur = parseInt(duration as string, 10)
    } else {
      dur =  duration as number;
    }
    if ((dur as number) < minBookingDuration || !dur || isNaN(+dur)) {
      dur = minBookingDuration;
    }
    return +dur;
  }

  public removeTablesStandbyBookingType(booking: IBooking): IBooking {
    if (!booking) {
      return null;
    }
    if (booking.bookingType === BookingType.StandbyList && booking.status.statusType !== bookingStatusType.standbyPending) {
      booking.tables = [];
    }
    return booking;
  }

  private NormalizeBookingTimeChangeLogEntry(entry: IBookingTimeChangelogEntryFromPouch) : IBookingTimeChangelogEntry
  {
    return {
      version: entry.version,
      time: moment(entry.time).toDate(),
    }
  }

  __forTests(): any {
    return {
      normalizePreAuthRelease: this.normalizePreAuthRelease,
    };
  }

  private normalizePreAuthRelease(booking: IBooking){
    //Some pre-requisite checks
    if(!booking.paymentSummary){
      return;
    }

    if(booking.paymentSummary.paymentType !== servicePaymentType.preAuth)
    {
      return;
    }

    if(booking.paymentSummary.preAuthStatus !== preAuthStatus.holding){
      return;
    }

    const venue = AdminService.getVenue();
    
    if(!venue.paymentSettings){
      return;
    }
        
    const timeZoneId = AdminService.getVenueTimezoneId();
    const currentTime = DateUtilsService.getVenueTime(timeZoneId);
    //preAuthReleasingWindow is in hours, convert to minutes for DateUtilsService function
    const expiryTime = DateUtilsService.addMinutes(booking.time, venue.paymentSettings.preAuthReleasingWindow * 60.0)
    //Preauth window has expired, view should act as if this preauth has been released.
    if(currentTime.getTime() > expiryTime.getTime()){
      booking.paymentSummary.preAuthStatus = preAuthStatus.released;
      booking.paymentSummary.preAuthReleasedAmount = booking.paymentSummary.amountDue;
    }
  }
}

const instance = new BookingNormaliseService();
export default instance as BookingNormaliseService;
